export var GatekeeperNetwork;
(function (GatekeeperNetwork) {
    GatekeeperNetwork["GENESIS"] = "genesis";
    GatekeeperNetwork["IGNITE"] = "ignite";
    GatekeeperNetwork["NILE"] = "nile";
    GatekeeperNetwork["BLUENILE"] = "blueNile";
    GatekeeperNetwork["MOSELLE"] = "moselle";
    GatekeeperNetwork["UNIQUENESS"] = "uniqueness";
    GatekeeperNetwork["VAAL"] = "vaal";
})(GatekeeperNetwork || (GatekeeperNetwork = {}));
